import styled from 'styled-components';

export const Container = styled.div`
  padding: 16px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  h2 {
    margin: 0;
    font-size: 1.25rem;
    color: #333;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #666;

  &:hover {
    color: #333;
  }
`;

export const SlotsTable = styled.div`
  margin-bottom: 24px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  max-height: 300px;
  overflow-y: auto;
`;

export const SlotsTableHeader = styled.div`
  display: grid;
  grid-template-columns: 60px 100px 100px 1fr 120px 1fr;
  gap: 8px;
  padding: 10px 12px;
  background-color: #031795;
  color: #fff;
  font-weight: bold;
  font-size: 0.75rem;
  position: sticky;
  top: 0;
  z-index: 1;
`;

export const SlotsTableRow = styled.div`
  display: grid;
  grid-template-columns: 60px 100px 100px 1fr 120px 1fr;
  gap: 8px;
  padding: 8px 12px;
  font-size: 0.8125rem;
  border-bottom: 1px solid #e0e0e0;
  background-color: ${props => props.$index % 2 === 0 ? '#fff' : '#f5f5f5'};

  &:last-child {
    border-bottom: none;
  }
`;

export const FormSection = styled.div`
  margin-bottom: 16px;
`;

export const FilesContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;

  svg {
    margin-left: 8px;
    cursor: pointer;
  }
`;

export const Dropzone = styled.div`
  width: 100%;
  height: 120px;
  border: 2px dashed #000;
  margin-top: 16px;

  display: flex;
  align-items: center;
  justify-content: center;

  p {
    font-size: 18px;
    color: #465eb6;
    font-weight: bold;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`;
